export default __webpack_public_path__ + "static/media/undraw_not_found_60pq.6be1e901.png";